
import React from 'react';

const QualityAssurance = () => {
  const qualityPoints = [
    {
      icon: 'ri-seedling-line',
      title: '源头把控',
      description: '严选云南高海拔茶园，确保原料品质',
      stats: '3000米+',
      label: '海拔茶园'
    },
    {
      icon: 'ri-microscope-line',
      title: '科学检测',
      description: '146项农残检测，重金属检测全面达标',
      stats: '146项',
      label: '检测标准'
    },
    {
      icon: 'ri-award-line',
      title: '工艺传承',
      description: '传承三百年古法制茶技艺，现代化生产管理',
      stats: '300年',
      label: '技艺传承'
    },
    {
      icon: 'ri-shield-check-line',
      title: '质量保证',
      description: '全程可追溯体系，每饼茶叶都有身份证',
      stats: '100%',
      label: '可追溯'
    }
  ];

  const certificationLogos = [
    {
      name: '有机认证',
      logo: 'https://public.readdy.ai/ai/img_res/c45a6c7614d85d86cb8e314f1f0111b0.jpg'
    },
    {
      name: 'ISO22000',
      logo: 'https://readdy.ai/api/search-image?query=ISO%2022000%20certification%20logo%20with%20blue%20and%20white%20design%2C%20international%20standards%20symbol%2C%20official%20certification%20seal%2C%20clean%20professional%20layout&width=120&height=120&seq=logo-iso&orientation=squarish'
    },
    {
      name: '地理标志',
      logo: 'https://readdy.ai/api/search-image?query=Geographic%20indication%20protection%20logo%20with%20Chinese%20map%20elements%2C%20golden%20seal%20design%2C%20official%20government%20certification%20mark%2C%20traditional%20style&width=120&height=120&seq=logo-geographic&orientation=squarish'
    },
    {
      name: '绿色食品',
      logo: 'https://readdy.ai/api/search-image?query=Green%20food%20certification%20logo%20with%20green%20circle%20and%20leaf%2C%20Chinese%20green%20food%20official%20symbol%2C%20clean%20environmental%20design%2C%20certification%20seal&width=120&height=120&seq=logo-green&orientation=squarish'
    },
    {
      name: '中华老字号',
      logo: 'https://readdy.ai/api/search-image?query=Chinese%20time-honored%20brand%20logo%20with%20traditional%20golden%20dragon%20design%2C%20official%20heritage%20symbol%2C%20classic%20Chinese%20cultural%20elements%2C%20prestigious%20certification%20mark&width=120&height=120&seq=logo-heritage&orientation=squarish'
    },
    {
      name: '非遗传承',
      logo: 'https://readdy.ai/api/search-image?query=Intangible%20cultural%20heritage%20logo%20with%20traditional%20Chinese%20cultural%20patterns%2C%20official%20heritage%20protection%20symbol%2C%20classic%20design%20elements%2C%20cultural%20certification%20mark&width=120&height=120&seq=logo-intangible&orientation=squarish'
    }
  ];

  return (
    <section className="py-12 lg:py-16 bg-white">
      <div className="px-6 lg:px-16">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-primary font-serif mb-3">
            品质保障
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            从茶园到茶杯，每一个环节都严格把控，确保为您奉献最高品质的普洱茶
          </p>
        </div>

        {/* Quality Points */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 mb-12 lg:mb-16">
          {qualityPoints.map((point, index) => (
            <div
              key={index}
              className="text-center bg-gray-50 rounded-xl p-4 lg:p-6 hover:shadow-lg transition-all duration-300 hover:scale-105 border border-gray-100"
            >
              <div className="w-12 h-12 lg:w-16 lg:h-16 mx-auto mb-3 lg:mb-4 bg-accent/10 rounded-full flex items-center justify-center">
                <i className={`${point.icon} text-lg lg:text-2xl text-accent`}></i>
              </div>
              
              <div className="mb-2 lg:mb-3">
                <div className="text-lg lg:text-2xl font-bold text-primary font-serif">
                  {point.stats}
                </div>
                <div className="text-xs text-gray-500">
                  {point.label}
                </div>
              </div>
              
              <h3 className="text-sm lg:text-base font-bold text-primary font-serif mb-2">
                {point.title}
              </h3>
              
              <p className="text-xs lg:text-sm text-gray-600 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        {/* Certification Logos */}
        <div className="bg-gray-50 rounded-xl p-6 lg:p-8">
          <h3 className="text-xl font-bold text-primary font-serif text-center mb-6">
            权威认证标识
          </h3>
          
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-4 lg:gap-6">
            {certificationLogos.map((cert, index) => (
              <div
                key={index}
                className="text-center group"
              >
                <div className="w-20 h-20 lg:w-24 lg:h-24 mx-auto mb-2 bg-white rounded-lg flex items-center justify-center shadow-sm group-hover:shadow-md transition-all duration-300 border border-gray-100">
                  <img
                    src={cert.logo}
                    alt={cert.name}
                    className="w-12 h-12 lg:w-14 lg:h-14 object-contain"
                  />
                </div>
                <p className="text-xs text-gray-600 font-medium">
                  {cert.name}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center mt-12 lg:mt-16">
          <div className="bg-primary rounded-xl p-6 lg:p-8 text-white">
            <h3 className="text-xl lg:text-2xl font-bold font-serif mb-3">
              品质承诺
            </h3>
            <p className="text-sm lg:text-base text-gray-200 mb-6 max-w-2xl mx-auto leading-relaxed">
              马帮瑞贡承诺：每一饼茶叶都经过严格质量检验，如有质量问题，我们提供无条件退换货服务
            </p>
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 text-sm max-w-2xl mx-auto">
              <div className="flex flex-col items-center space-y-2">
                <i className="ri-shield-check-line text-accent text-lg"></i>
                <span>质量保证</span>
              </div>
              <div className="flex flex-col items-center space-y-2">
                <i className="ri-refund-line text-accent text-lg"></i>
                <span>无条件退换</span>
              </div>
              <div className="flex flex-col items-center space-y-2">
                <i className="ri-customer-service-line text-accent text-lg"></i>
                <span>专业服务</span>
              </div>
              <div className="flex flex-col items-center space-y-2">
                <i className="ri-truck-line text-accent text-lg"></i>
                <span>全国包邮</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default QualityAssurance;
